import clienteAxios from "../config/axios";

export async function getAllNivel2s() {
    return clienteAxios.get(`/nivel2`);
}

export async function addNivel2(datos) {
    
    const codNivel2 = datos.codNivel2
    const name = datos.name
    const descrp = datos.descrp
    const nivel2Nivel1ID = datos.nivel2Nivel1._id
    const codNivel1 = datos.nivel2Nivel1.codNivel1
    const direccion = datos.direccion || null
    const lat = datos.lat || null
    const lng = datos.lng || null

    return clienteAxios.post(`/nivel2`,{codNivel2, name, descrp, nivel2Nivel1ID, codNivel1, direccion, lat, lng});
}

export async function updateNivel2(dato) {
    
    const id = dato.id
    const updates = {
        id: dato.id,
        codNivel2:dato.codNivel2,
        name: dato.name,
        descrp: dato.descrp,
        direccion: dato.direccion || null,
        lat: dato.lat || null,
        lng: dato.lng || null
    }

    return clienteAxios.put(`/nivel2/${id}`,updates);
}

export async function deleteNivel2(id) {
   
    return clienteAxios.delete(`/nivel2/${id}`,id);

}

export async function deleteNivel2AndChildren(id, deleteActivesToo) {
    return clienteAxios.delete(`/nivel2/deleteLevelAndChildren/${id}?deleteActivesToo=${deleteActivesToo}`,{id});
}


export async function updatePositioning(updates){
    return clienteAxios.post(`/nivel2/updatePositioning`,{updates});
}